import { render, staticRenderFns } from "./QuickFixDialogBase.vue?vue&type=template&id=71a4d32a&scoped=true&"
import script from "./QuickFixDialogBase.vue?vue&type=script&lang=js&"
export * from "./QuickFixDialogBase.vue?vue&type=script&lang=js&"
import style0 from "./QuickFixDialogBase.vue?vue&type=style&index=0&id=71a4d32a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a4d32a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
